// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4cf8fced","186":"ec179003","272":"8dce27db","567":"82d44d15","738":"8a55da77","841":"f3f2d54a","851":"96d03fa8","996":"520ca563"}[chunkId] + ".chunk.js";
};